<template>
  <div class="img-and-content-container">
    <div class="img-and-content-inner">
      <h2 class="title">{{ $dt(eleConfig, 'title') }}</h2>
      <a-row :gutter="[68, 30]">
        <a-col v-for="(item,i) in eleConfig.dataList" :key="item._id" :span="12">
          <div class="data-item" :key="item._id">
            <div class="item-index">0{{ i + 1 }}</div>
            <div class="item-img">
              <img :src="imgList[i]" />
            </div>
            <div class="item-text">
              <div class="item-title">{{ $dt(item, 'title') }}</div>
              <div class="item-content">{{ $dt(item, 'content') }}</div>
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import componentMixin from './componentMixin';
import spg1 from '../../../public/static/customPage/spg1.svg';
import spg2 from '../../../public/static/customPage/spg2.svg';
import spg3 from '../../../public/static/customPage/spg3.svg';
import spg4 from '../../../public/static/customPage/spg4.svg';
import spg5 from '../../../public/static/customPage/spg5.svg';
import spg6 from '../../../public/static/customPage/spg6.svg';

export default {
  name: "specialG",
  mixins: [componentMixin],
  data() {
    return {
      imgList: [spg1, spg2, spg3, spg4, spg5, spg6],
    }
  },
  computed: {}
};
</script>

<style scoped lang="scss">
.img-and-content-container {
  width: 100%;
  padding: 96px 0;
  background: #ffffff;

  .img-and-content-inner {
    width: 1280px;
    margin: 0 auto;

    .title {
      font-size: 32px;
      font-weight: 600;
      margin-bottom: 16px;
      line-height: 45px;
      color: #003C82;
    }
  }

  .data-item {
    display: flex;
    background-image: url("../../../public/static/customPage/spgBg.jpg");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;
    height: 190px;
    padding: 66px 35px 18px 54px;

    .item-index {
      position: absolute;
      top: 6px;
      left: 74px;
      font-size: 28px;
      color: #fff;
    }

    .item-img {
      align-self: flex-end;
      width: 68px;
      height: 68px;
      margin-right: 40px;
      margin-bottom: 22px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .item-text {
      flex: 1;
      align-self: flex-start;

      .item-title {
        font-size: 24px;
        color: #333333;
        line-height: 33px;
        font-weight: 600;
        margin-bottom: 12px;
      }

      .item-content {
        color: #333333;
        line-height: 20px;
        white-space: pre-wrap;
      }
    }
  }
}
</style>
